module.exports = __webpack_public_path__ + "assets/images/magazine_7cd2e7b72cdc0f5051e8a24a9f329be0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-four/exercise-6/magazine.png
// module id = 282
// module chunks = 0